import { makeVar, ReactiveVar } from '@apollo/client';
import { produce } from 'immer';
import { PlanFragment, PlanState } from '@/graphql/generated/graphql';

export interface IPlanTemplate {
  data: PlanFragment;
}

export const currentPlanTemplateInitialState: IPlanTemplate = {
  data: {
    id: '',
    name: '',
    currentState: PlanState.Draft,
    currency: { id: '', code: 'USD', label: 'USA Dollar', popular: 'true', symbol: '$', exchangeRate: 1 },
    description: null,
    isTemplate: true,
    visible: false,
    archived: false,
    firstPublish: true,
  },
};

export const currentPlanTemplateVar: ReactiveVar<IPlanTemplate> = makeVar<IPlanTemplate>(
  currentPlanTemplateInitialState
);

export const setPlanTemplateData = (templateData: Partial<PlanFragment>) => {
  currentPlanTemplateVar(
    produce(currentPlanTemplateVar(), (draft) => {
      draft.data = {
        ...draft.data,
        ...templateData,
      };
    })
  );
};
